<template>
  <div class="admin-dashboard">
    <v-container fluid class="pa-6">
      <!-- Header Section -->
      <v-row class="mb-6">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between flex-wrap">
            <div>
              <h1 class="text-h4 font-weight-bold primary--text mb-1">
                <v-icon large color="primary" class="mr-2"
                  >mdi-file-document-check</v-icon
                >
                ระบบติดตามการเสนอรายชื่อผู้ทรงคุณวุฒิ
              </h1>
              <p class="text-subtitle-1 grey--text text--darken-1 mb-0">
                Dashboard สำหรับ Admin
                ติดตามและจัดการข้อมูลการเสนอรายชื่อของสถานศึกษา
              </p>
            </div>
            <div class="d-flex align-center">
              <v-chip color="success" outlined class="mr-3">
                <v-icon left small>mdi-calendar</v-icon>
                ปีการศึกษา
                {{ periodTeachersAssisstant.period_college_year || "-" }}
              </v-chip>
              <v-btn
                color="primary"
                @click="refreshData"
                :loading="loading"
                icon
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Statistics Cards -->
      <v-row class="mb-6">
        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-card--primary" elevation="4">
            <v-card-text class="pa-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p
                    class="text-caption text-uppercase font-weight-medium mb-1 white--text"
                    style="opacity: 0.8;"
                  >
                    สถานศึกษาทั้งหมด
                  </p>
                  <h2 class="text-h3 font-weight-bold white--text">
                    {{ colleges.length }}
                  </h2>
                </div>
                <v-avatar size="56" color="white" style="opacity: 0.2;">
                  <v-icon size="32" color="white">mdi-school</v-icon>
                </v-avatar>
              </div>
              <v-divider class="my-3" style="opacity: 0.3;"></v-divider>
              <div class="d-flex align-center">
                <v-icon small color="white" class="mr-1">mdi-chart-line</v-icon>
                <span class="text-caption white--text">จากระบบทะเบียน</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-card--success" elevation="4">
            <v-card-text class="pa-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p
                    class="text-caption text-uppercase font-weight-medium mb-1 white--text"
                    style="opacity: 0.8;"
                  >
                    เสนอรายชื่อแล้ว
                  </p>
                  <h2 class="text-h3 font-weight-bold white--text">
                    {{ statistics.submittedCount }}
                  </h2>
                </div>
                <v-avatar size="56" color="white" style="opacity: 0.2;">
                  <v-icon size="32" color="white">mdi-file-check</v-icon>
                </v-avatar>
              </div>
              <v-divider class="my-3" style="opacity: 0.3;"></v-divider>
              <div class="d-flex align-center">
                <v-icon small color="white" class="mr-1">mdi-percent</v-icon>
                <span class="text-caption white--text">
                  {{ submittedPercentage }}% ของทั้งหมด
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-card--warning" elevation="4">
            <v-card-text class="pa-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p
                    class="text-caption text-uppercase font-weight-medium mb-1 white--text"
                    style="opacity: 0.8;"
                  >
                    ถูกยกเลิก
                  </p>
                  <h2 class="text-h3 font-weight-bold white--text">
                    {{ statistics.cancelledCount }}
                  </h2>
                </div>
                <v-avatar size="56" color="white" style="opacity: 0.2;">
                  <v-icon size="32" color="white">mdi-file-cancel</v-icon>
                </v-avatar>
              </div>
              <v-divider class="my-3" style="opacity: 0.3;"></v-divider>
              <div class="d-flex align-center">
                <v-icon small color="white" class="mr-1">mdi-alert</v-icon>
                <span class="text-caption white--text">ต้องแก้ไข</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="stat-card stat-card--info" elevation="4">
            <v-card-text class="pa-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p
                    class="text-caption text-uppercase font-weight-medium mb-1 white--text"
                    style="opacity: 0.8;"
                  >
                    รอดำเนินการ
                  </p>
                  <h2 class="text-h3 font-weight-bold white--text">
                    {{ statistics.pendingCount }}
                  </h2>
                </div>
                <v-avatar size="56" color="white" style="opacity: 0.2;">
                  <v-icon size="32" color="white">mdi-clock-outline</v-icon>
                </v-avatar>
              </div>
              <v-divider class="my-3" style="opacity: 0.3;"></v-divider>
              <div class="d-flex align-center">
                <v-icon small color="white" class="mr-1"
                  >mdi-file-document-outline</v-icon
                >
                <span class="text-caption white--text">รอตรวจสอบ</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filter Section -->
      <v-row class="mb-4">
        <v-col cols="12">
          <v-card elevation="2">
            <v-card-text class="pa-4">
              <v-row align="center">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi-magnify"
                    label="ค้นหาสถานศึกษา..."
                    outlined
                    dense
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="filterStatus"
                    :items="filterStatusOptions"
                    label="กรองตามสถานะ"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn
                    color="info"
                    outlined
                    @click="exportReport"
                    class="mr-2"
                  >
                    <v-icon left>mdi-file-excel</v-icon>
                    ส่งออกรายงาน
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Proposal Status Table -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="2">
            <v-card-title
              class="d-flex align-center justify-space-between py-4"
            >
              <div class="d-flex align-center">
                <v-icon color="info" class="mr-2"
                  >mdi-file-document-multiple</v-icon
                >
                <span class="text-h6 font-weight-bold"
                  >รายการเสนอรายชื่อผู้ทรงคุณวุฒิ</span
                >
              </div>
              <v-chip color="primary" small>
                {{ filteredProposals.length }} รายการ
              </v-chip>
            </v-card-title>

            <v-divider></v-divider>

            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="filteredProposals"
              :items-per-page="10"
              class="elevation-0"
            >
              <template v-slot:item.college_name="{ item }">
                <div class="d-flex align-center py-2">
                  <v-avatar size="36" color="info lighten-4" class="mr-3">
                    <span class="info--text text--darken-2 font-weight-medium">
                      {{ getCollegeInitials(item.college_name) }}
                    </span>
                  </v-avatar>
                  <div>
                    <div class="font-weight-medium">
                      {{ item.college_name || "-" }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ item.college_code }}
                    </div>
                  </div>
                </div>
              </template>

              <template v-slot:item.status="{ item }">
                <v-chip
                  small
                  :color="
                    getStatusColor(item.assistantcommitteeQualifiedCancelStatus)
                  "
                  text-color="white"
                  label
                >
                  <v-icon left small>{{
                    getStatusIcon(item.assistantcommitteeQualifiedCancelStatus)
                  }}</v-icon>
                  {{
                    getStatusText(item.assistantcommitteeQualifiedCancelStatus)
                  }}
                </v-chip>
              </template>

              <template v-slot:item.qualifiedCount="{ item }">
                <v-chip
                  small
                  :color="item.qualifiedCount > 0 ? 'primary' : 'grey'"
                  outlined
                >
                  {{ item.qualifiedCount || 0 }} คน
                </v-chip>
              </template>

              <template v-slot:item.proposal_file="{ item }">
                <v-btn
                  v-if="item.proposal_file"
                  icon
                  small
                  color="primary"
                  @click="viewPdfFile(item.proposal_file)"
                >
                  <v-icon small>mdi-file-pdf-box</v-icon>
                </v-btn>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.upload_date="{ item }">
                {{ item.upload_date || "-" }}
              </template>

              <template
                v-slot:item.assistantcommitteeQualifiedCancelReason="{ item }"
              >
                <v-tooltip
                  bottom
                  v-if="item.assistantcommitteeQualifiedCancelReason"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="text-truncate d-inline-block"
                      style="max-width: 150px;"
                    >
                      {{ item.assistantcommitteeQualifiedCancelReason }}
                    </span>
                  </template>
                  <span>{{
                    item.assistantcommitteeQualifiedCancelReason
                  }}</span>
                </v-tooltip>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="d-flex">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="viewDetail(item)"
                        class="mr-1"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>ดูรายละเอียด</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        @click="openApproveDialog(item)"
                      >
                        <v-icon small>mdi-check-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>อนุมัติ</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="openCancelDialog(item)"                        
                      >
                        <v-icon small>mdi-cancel</v-icon>
                      </v-btn>
                    </template>
                    <span>ยกเลิกรายการ</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Detail Dialog -->
    <v-dialog v-model="detailDialog" max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-file-document-outline</v-icon>
          รายละเอียดการเสนอรายชื่อ
          <v-spacer></v-spacer>
          <v-btn icon dark @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6" v-if="selectedItem">
          <v-row>
            <v-col cols="12">
              <div class="detail-section mb-4">
                <h4 class="text-subtitle-2 grey--text mb-3">ข้อมูลสถานศึกษา</h4>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-domain</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>รหัสสถานศึกษา</v-list-item-subtitle>
                      <v-list-item-title>{{
                        selectedItem.college_code
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-school</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ชื่อสถานศึกษา</v-list-item-subtitle>
                      <v-list-item-title>{{
                        selectedItem.college_name || "-"
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-section">
                <h4 class="text-subtitle-2 grey--text mb-3">ข้อมูลการเสนอ</h4>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-calendar</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ปีการศึกษา</v-list-item-subtitle>
                      <v-list-item-title>{{
                        selectedItem.period_year
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-clock</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>วันที่เสนอ</v-list-item-subtitle>
                      <v-list-item-title>{{
                        selectedItem.upload_date || "-"
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small
                        >mdi-account-group</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >จำนวนผู้ทรงคุณวุฒิ</v-list-item-subtitle
                      >
                      <v-list-item-title
                        >{{
                          selectedItem.qualifiedCount || 0
                        }}
                        คน</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="detail-section">
                <h4 class="text-subtitle-2 grey--text mb-3">สถานะ</h4>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon small>mdi-flag</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>สถานะปัจจุบัน</v-list-item-subtitle>
                      <v-list-item-title>
                        <v-chip
                          small
                          :color="
                            getStatusColor(
                              selectedItem.assistantcommitteeQualifiedCancelStatus
                            )
                          "
                          text-color="white"
                        >
                          {{
                            getStatusText(
                              selectedItem.assistantcommitteeQualifiedCancelStatus
                            )
                          }}
                        </v-chip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      selectedItem.assistantcommitteeQualifiedCancelStatus ===
                        'cancel_proposal_file'
                    "
                  >
                    <v-list-item-icon
                      ><v-icon small color="error"
                        >mdi-alert-circle</v-icon
                      ></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >เหตุผลที่ยกเลิก</v-list-item-subtitle
                      >
                      <v-list-item-title class="error--text">
                        {{
                          selectedItem.assistantcommitteeQualifiedCancelReason ||
                            "-"
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="selectedItem.assistantcommitteeQualifiedCancelledBy"
                  >
                    <v-list-item-icon
                      ><v-icon small>mdi-account</v-icon></v-list-item-icon
                    >
                    <v-list-item-content>
                      <v-list-item-subtitle>ยกเลิกโดย</v-list-item-subtitle>
                      <v-list-item-title>{{
                        selectedItem.assistantcommitteeQualifiedCancelledBy
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
            <v-col cols="12" v-if="selectedItem.proposal_file">
              <div class="detail-section">
                <h4 class="text-subtitle-2 grey--text mb-3">ไฟล์เอกสาร</h4>
                <v-btn
                  color="primary"
                  outlined
                  @click="viewPdfFile(selectedItem.proposal_file)"
                >
                  <v-icon left>mdi-file-pdf-box</v-icon>
                  ดูเอกสาร PDF
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="detailDialog = false">ปิด</v-btn>
          <v-btn
            color="error"
            @click="openCancelDialogFromDetail"
            :disabled="
              selectedItem &&
                selectedItem.assistantcommitteeQualifiedCancelStatus ===
                  'cancel_proposal_file'
            "
          >
            <v-icon left>mdi-cancel</v-icon>
            ยกเลิกรายการ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cancel Confirmation Dialog -->
    <v-dialog v-model="cancelDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-alert-circle</v-icon>
          ยืนยันการยกเลิก
        </v-card-title>
        <v-card-text class="pa-6">
          <p class="mb-4">ต้องการยกเลิกการเสนอรายชื่อของสถานศึกษานี้หรือไม่?</p>
          <v-alert type="warning" dense text v-if="cancelTarget" class="mb-4">
            <strong>{{
              cancelTarget.college_name || cancelTarget.college_code
            }}</strong>
          </v-alert>
          <v-textarea
            v-model="cancelReason"
            label="เหตุผลในการยกเลิก"
            placeholder="กรุณาระบุเหตุผลในการยกเลิก..."
            outlined
            dense
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeCancelDialog">ยกเลิก</v-btn>
          <v-btn color="error" @click="confirmCancel" :loading="cancelLoading">
            <v-icon left>mdi-check</v-icon>
            ยืนยันยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve Confirmation Dialog -->
    <v-dialog v-model="approveDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="success white--text">
          <v-icon left color="white">mdi-check-circle</v-icon>
          อนุมัติการเสนอรายชื่อ
        </v-card-title>
        <v-card-text class="pa-6">
          <p class="mb-4">
            ต้องการอนุมัติการเสนอรายชื่อของสถานศึกษานี้หรือไม่?
          </p>
          <v-alert type="success" dense text v-if="approveTarget" class="mb-4">
            <strong>{{
              approveTarget.college_name || approveTarget.college_code
            }}</strong>
          </v-alert>
          <v-textarea
            v-model="approveReason"
            label="หมายเหตุ (ไม่บังคับ)"
            placeholder="กรุณาระบุหมายเหตุหากมี..."
            outlined
            dense
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeApproveDialog">ยกเลิก</v-btn>
          <v-btn
            color="success"
            @click="confirmApprove"
            :loading="ApproveLoading"
          >
            <v-icon left>mdi-check</v-icon>
            ยืนยันอนุมัติ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PDF Viewer Dialog -->
    <v-dialog v-model="pdfDialog" max-width="80%">
      <v-card>
        <v-card-title
          class="d-flex align-center justify-space-between primary white--text"
        >
          <div class="d-flex align-center">
            <v-icon left color="white">mdi-file-pdf-box</v-icon>
            <span>เอกสารยืนยันการเสนอรายชื่อ</span>
          </div>
          <v-btn icon dark @click="pdfDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <embed
            :src="pdfBaseUrl + pdfFile"
            width="100%"
            height="700px"
            type="application/pdf"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "AdminAssistantCommitteeProposal",

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: true,
      cancelLoading: false,
      ApproveLoading: false,
      search: "",

      // Filter
      filterStatus: "all",
      filterStatusOptions: [
        { text: "ทั้งหมด", value: "all" },
        { text: "รอดำเนินการ", value: "pending" },
        { text: "ถูกยกเลิก", value: "cancelled" }
      ],

      // Data
      proposals: [],
      colleges: [],
      periodTeachersAssisstant: {},

      // Statistics
      statistics: {
        submittedCount: 0,
        cancelledCount: 0,
        pendingCount: 0
      },

      // Dialogs
      detailDialog: false,
      cancelDialog: false,
      pdfDialog: false,
      selectedItem: null,
      cancelTarget: null,
      cancelReason: "",

      approveDialog: false,
      approveTarget: null,
      approveReason: "",

      pdfFile: "",
      pdfBaseUrl: "/HRProposalConfirm/",

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      },

      // Table Headers
      headers: [
        { text: "สถานศึกษา", value: "college_name", width: "280" },
        { text: "สถานะ", value: "status", align: "center", width: "150" },
        {
          text: "จำนวนผู้ทรง",
          value: "qualifiedCount",
          align: "center",
          width: "120"
        },
        {
          text: "ไฟล์เอกสาร",
          value: "proposal_file",
          align: "center",
          width: "100"
        },
        { text: "วันที่เสนอ", value: "upload_date", width: "150" },
        {
          text: "เหตุผลยกเลิก",
          value: "assistantcommitteeQualifiedCancelReason",
          width: "180"
        },
        {
          text: "จัดการ",
          value: "actions",
          align: "center",
          sortable: false,
          width: "120"
        }
      ]
    };
  },

  computed: {
    submittedPercentage() {
      if (this.colleges.length === 0) return 0;
      return (
        (this.statistics.submittedCount / this.colleges.length) *
        100
      ).toFixed(1);
    },

    filteredProposals() {
      let data = this.proposals;

      // Filter by status
      if (this.filterStatus === "pending") {
        data = data.filter(
          item =>
            !item.assistantcommitteeQualifiedCancelStatus ||
            item.assistantcommitteeQualifiedCancelStatus !==
              "cancel_proposal_file"
        );
      } else if (this.filterStatus === "cancelled") {
        data = data.filter(
          item =>
            item.assistantcommitteeQualifiedCancelStatus ===
            "cancel_proposal_file"
        );
      }

      // Filter by search
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        data = data.filter(item => {
          return (
            (item.college_name &&
              item.college_name.toLowerCase().includes(searchLower)) ||
            (item.college_code &&
              item.college_code.toLowerCase().includes(searchLower))
          );
        });
      }

      return data;
    }
  },

  async mounted() {
    await this.initializeData();
  },

  methods: {
    async initializeData() {
      this.loading = true;
      try {
        await this.periodQueryTeacherAssisstant();
        await this.collegeQueryAll();
        await this.proposalsQueryAll();
        this.calculateStatistics();
      } catch (error) {
        console.error("Error initializing data:", error);
        this.showSnackbar(
          "error",
          "mdi-alert",
          "เกิดข้อผิดพลาดในการโหลดข้อมูล"
        );
      } finally {
        this.loading = false;
      }
    },

    async refreshData() {
      await this.initializeData();
      this.showSnackbar("success", "mdi-check", "รีเฟรชข้อมูลเรียบร้อย");
    },

    async periodQueryTeacherAssisstant() {
      const result = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "60101"
      });
      this.periodTeachersAssisstant = result.data;
    },

    async collegeQueryAll() {
      const result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data || [];
    },

    async proposalsQueryAll() {
      const result = await this.$http.post(
        "assistantcommitteequalified_proposal.php",
        {
          ApiKey: this.ApiKey,
          action: "get_proposal_admin",
          period_year: this.periodTeachersAssisstant.period_college_year
        }
      );

      if (Array.isArray(result.data)) {
        this.proposals = result.data;
      } else {
        this.proposals = [];
      }
    },

    calculateStatistics() {
      const data = this.proposals;

      // จำนวนที่เสนอแล้วทั้งหมด
      this.statistics.submittedCount = data.length;

      // จำนวนที่ถูกยกเลิก
      this.statistics.cancelledCount = data.filter(
        item =>
          item.assistantcommitteeQualifiedCancelStatus ===
          "cancel_proposal_file"
      ).length;

      // จำนวนที่รอดำเนินการ (ไม่ถูกยกเลิก)
      this.statistics.pendingCount = data.filter(
        item =>
          !item.assistantcommitteeQualifiedCancelStatus ||
          item.assistantcommitteeQualifiedCancelStatus !==
            "cancel_proposal_file"
      ).length;
    },

    // View Methods
    viewDetail(item) {
      this.selectedItem = item;
      this.detailDialog = true;
    },

    viewPdfFile(filename) {
      this.pdfFile = filename;
      this.pdfDialog = true;
    },

    // Cancel Methods
    openCancelDialog(item) {
      this.cancelTarget = item;
      this.cancelReason = "";
      this.cancelDialog = true;
    },

    openApproveDialog(item) {
      this.approveTarget = item;
      this.approveReason = "";
      this.approveDialog = true;
    },

    openCancelDialogFromDetail() {
      if (this.selectedItem) {
        this.cancelTarget = this.selectedItem;
        this.cancelReason = "";
        this.detailDialog = false;
        this.cancelDialog = true;
      }
    },

    closeCancelDialog() {
      this.cancelDialog = false;
      this.cancelTarget = null;
      this.cancelReason = "";
    },

    closeApproveDialog() {
      this.approveDialog = false;
      this.approveTarget = null;
      this.approveReason = "";
    },

    async confirmCancel() {
      if (!this.cancelReason.trim()) {
        this.showSnackbar(
          "warning",
          "mdi-alert",
          "กรุณาระบุเหตุผลในการยกเลิก"
        );
        return;
      }

      this.cancelLoading = true;
      try {
        const result = await this.$http.post(
          "assistantcommitteequalified_proposal.php",
          {
            ApiKey: this.ApiKey,
            action: "approve_cancel_proposal",
            id: this.cancelTarget.id,
            reason: this.cancelReason,
            college_code: this.cancelTarget.college_code
          }
        );
        if (result.data.status === true) {
          this.showSnackbar(
            "warning",
            "mdi-cancel",
            "ยกเลิกรายการเรียบร้อยแล้ว"
          );
          await this.proposalsQueryAll();
          this.calculateStatistics();
          this.closeCancelDialog();
        } else {
          this.showSnackbar(
            "error",
            "mdi-alert",
            result.data.message || "เกิดข้อผิดพลาด"
          );
        }
      } catch (error) {
        console.error("Error cancelling proposal:", error);
        this.showSnackbar("error", "mdi-alert", "เกิดข้อผิดพลาดในการยกเลิก");
      } finally {
        this.cancelLoading = false;
      }
    },

    async confirmApprove() {
      this.ApproveLoading = true;
      try {
        const result = await this.$http.post(
          "assistantcommitteequalified_proposal.php",
          {
            ApiKey: this.ApiKey,
            action: "approve_proposal",
            id: this.approveTarget.id,
            reason: this.approveReason || "อนุมัติการเสนอรายชื่อ",
            college_code: this.approveTarget.college_code
          }
        );
        if (result.data.status === true) {
          this.showSnackbar(
            "success",
            "mdi-check",
            "อนุมัติการเสนอรายชื่อเรียบร้อยแล้ว"
          );
          await this.proposalsQueryAll();
          this.calculateStatistics();
          this.closeApproveDialog();
        } else {
          this.showSnackbar(
            "error",
            "mdi-alert",
            result.data.message || "เกิดข้อผิดพลาด"
          );
        }
      } catch (error) {
        console.error("Error approving proposal:", error);
        this.showSnackbar("error", "mdi-alert", "เกิดข้อผิดพลาดในการอนุมัติ");
      } finally {
        this.ApproveLoading = false;
      }
    },

    // Export Methods
    exportReport() {
      const data = this.filteredProposals.map(item => ({
        รหัสสถานศึกษา: item.college_code,
        ชื่อสถานศึกษา: item.college_name || "-",
        ปีการศึกษา: item.period_year,
        สถานะ: this.getStatusText(item.assistantcommitteeQualifiedCancelStatus),
        จำนวนผู้ทรงคุณวุฒิ: item.qualifiedCount || 0,
        วันที่เสนอ: item.upload_date || "-",
        เหตุผลยกเลิก: item.assistantcommitteeQualifiedCancelReason || "-",
        ยกเลิกโดย: item.assistantcommitteeQualifiedCancelledBy || "-"
      }));

      if (data.length === 0) {
        this.showSnackbar(
          "warning",
          "mdi-alert-circle",
          "ไม่พบข้อมูลที่ต้องการส่งออก"
        );
        return;
      }

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ProposalReport");

      // Auto-width columns
      const colWidths = Object.keys(data[0] || {}).map(key => ({
        wch:
          Math.max(
            key.length,
            ...data.map(row => String(row[key] || "").length)
          ) + 2
      }));
      ws["!cols"] = colWidths;

      XLSX.writeFile(
        wb,
        `รายงานการเสนอรายชื่อ_${this.formatDateForFile(new Date())}.xlsx`
      );
      this.showSnackbar("success", "mdi-file-excel", "ส่งออกรายงานเรียบร้อย");
    },

    // Helper Methods
    getCollegeInitials(name) {
      if (!name) return "?";
      const words = name.split(" ");
      return words.length > 1
        ? words[0][0] + words[1][0]
        : name.substring(0, 2);
    },

    getStatusColor(status) {
      if (status === "cancel_proposal_file") {
        return "error";
      } else if (status === "approve_proposal") {
        return "info";
      }

      return "success";
    },

    getStatusIcon(status) {
      if (status === "cancel_proposal_file") {
        return "mdi-close-circle";
      } else if (status === "approve_proposal") {
        return "mdi-information";
      }
      return "mdi-check-circle";
    },

    getStatusText(status) {
      if (status === "cancel_proposal_file") {
        return "ขอยกเลิก";
      } else if (status === "approve_proposal") {
        return "อนุมัติแล้ว";
      }
      return "เสนอแล้ว";
    },

    formatDateForFile(date) {
      return date.toISOString().split("T")[0];
    },

    showSnackbar(color, icon, text) {
      this.snackbar = {
        show: true,
        color,
        icon,
        text,
        timeout: 4000
      };
    }
  }
};
</script>

<style scoped>
.admin-dashboard {
  background: linear-gradient(135deg, #f5f5f5 0%, #e4e8ec 100%);
  min-height: 100vh;
}

.stat-card {
  border-radius: 16px !important;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.stat-card--primary {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%);
}

.stat-card--success {
  background: linear-gradient(135deg, #2e7d32 0%, #2e7d32 100%);
}

.stat-card--warning {
  background: linear-gradient(135deg, #A86400 0%, #A86400 100%);
}

.stat-card--info {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%);
}

.detail-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

::v-deep .v-data-table thead th {
  font-weight: 600 !important;
  font-size: 13px !important;
  background: #f5f5f5 !important;
}

::v-deep .v-data-table tbody tr:hover {
  background: #f5f5f5 !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>